var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gap-filler-input",class:( _obj = {}, _obj[_vm.status] = true, _obj['show-status'] =  _vm.showAnswers, _obj )},[_c('input',{ref:"input",attrs:{"type":"number"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.inputValue($event.target.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }